<template>
  <section class="product-selector">
    <div class="dialog-header">
      <h1>Ontwerp toevoegen</h1>
      <popup-menu class="filter">
        <span slot="trigger" class="trigger"
          ><span
            class="filtered-collection"
            v-if="!selectedCollection || selectedCollection.id == 0"
            >Filter</span
          >
          <span v-else class="filtered-collection">{{
            selectedCollection.name
          }}</span>
          <button class="chevron down"></button>
        </span>
        <menu-item
          v-for="collection in collections"
          :key="collection.id"
          @click="setCollectionFilter(collection)"
          >{{ collection.name }}
        </menu-item>
      </popup-menu>
      <toggle class="toggle" @action="selectAll" :active="allSelected"></toggle>
    </div>
    <div class="dialog-content">
      <div class="product-container">
        <product
          v-for="(product, index) in filteredProducts"
          :product="product"
          :key="index"
          :selected="selectedProducts.indexOf(product) > -1"
          :in-package="isInPackage(product.id)"
          @click.native="selectProduct(product, 'single')"
          @selectBox="selectProduct(product)"
          :show-select-box="true"
          :show-specs="false"
        >
        </product>
      </div>

      <div class="button-holder">
        <span class="select-text" v-show="this.selectedProducts.length > 0"
          >{{ this.selectedProducts.length }} ontwerp<span
            v-show="this.selectedProducts.length !== 1"
            >en</span
          ></span
        >
        <button
          class="pill-button"
          :disabled="selectedProducts.length < 1"
          @click="addToPackage"
        >
          Toevoegen aan pakket
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Product from './Product.vue'
import {
  getAllProducts,
  getCollections
} from '@/features/printstore/PrintStoreApi'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import Toggle from '../../../../components/ui/Toggle.vue'

export default {
  components: { Product, Toggle },
  async mounted() {
    this.products = await getAllProducts()
    this.selectedCollection = this.printStoreStore.collectionFilter
    this.filterProducts()

    this.collections = [{ id: '0', name: 'Alles' }, ...(await getCollections())]
  },
  props: ['callback', 'packageProducts'],
  data() {
    return {
      products: [],
      filteredProducts: [],
      collections: [],
      selectedCollection: undefined,
      selectedProducts: []
    }
  },
  methods: {
    selectAll() {
      const found = this.selectedProducts.some(
        (prod) => this.filteredProducts.indexOf(prod) >= 0
      )
      //none of filteredProducts are selected, select all
      if (!found) {
        this.selectedProducts.push(...this.filteredProducts)
        //this.allSelected = true
      } else if (
        //all filteredProducts are selected, remove them from selected
        this.filteredProducts.every((prod) =>
          this.selectedProducts.includes(prod)
        )
      ) {
        this.filteredProducts.forEach((prod) => {
          this.selectedProducts.splice(this.selectedProducts.indexOf(prod), 1)
        })
        //this.allSelected = false
      } else {
        // some filteredProducts are selected, add rest to selected
        this.filteredProducts.forEach((prod) => {
          if (this.selectedProducts.indexOf(prod) === -1) {
            this.selectedProducts.push(prod)
          }
        })
      }
    },
    setCollectionFilter(collection) {
      this.printStoreStore.setCollectionFilter(collection)
      this.selectedCollection = collection
      this.filterProducts()
    },
    filterProducts() {
      if (this.selectedCollection.id === '0') {
        this.filteredProducts = this.products
      } else {
        this.filteredProducts = this.products.filter((product) =>
          product.collections
            .map((collection) => collection.id)
            .includes(this.selectedCollection.id)
        )
      }
    },
    selectProduct(product, type) {
      if (this.selectedProducts.indexOf(product) === -1) {
        this.selectedProducts.push(product)
      } else {
        this.selectedProducts.splice(this.selectedProducts.indexOf(product), 1)
      }
    },
    isInPackage(id) {
      if (this.packageProducts.some((e) => e.id === id)) {
        return true
      } else {
        return false
      }
    },
    addToPackage() {
      //before adding products to package, add the default printspecs:
      this.selectedProducts.forEach((prod) => {
        prod.quantity = 1
        let pSpecs = {}

        pSpecs[prod.printSpecification.products['title']] =
          prod.printSpecification.products.values[
            prod.printSpecification.products.default
          ]

        if (prod.printSpecification.colors) {
          pSpecs[prod.printSpecification.colors['title']] =
            prod.printSpecification.colors.values[
              prod.printSpecification.colors.default
            ].name

          const defaultColor = prod.printSpecification.colors.default
          const defaultImg = prod.previews.find(
            (img) => img.colour === defaultColor
          )

          prod.previewImage = defaultImg.uuid
        } else if (prod.hasVariants) {
          prod.previewImage = prod.previews[0].uuid
        }

        pSpecs[prod.printSpecification.specs[0].title] =
          prod.printSpecification.specs[0].values[
            prod.printSpecification.specs[0].default
          ]

        pSpecs.title = prod.printSpecification.title

        if (prod.hasVariants) {
          prod.variant = {
            size: prod.printSpecification.products.default,
            application: prod.printSpecification.specs[0].default,
            previewImage: prod.previewImage
          }

          if (prod.printSpecification.colors) {
            prod.variant.color = prod.printSpecification.colors.default
          }
        }

        prod.printSpecification = pSpecs
      })

      this.callback(this.selectedProducts)
      this.$emit('close')
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    allSelected() {
      return this.filteredProducts.every((prod) =>
        this.selectedProducts.includes(prod)
      ) && this.selectedProducts.length > 0
        ? true
        : false
    }
  }
}
</script>

<style lang="scss" scoped>
.product-container {
  height: 409px;
  overflow: auto;
  margin-right: -25px;
  padding-right: 25px;
  margin-bottom: 20px;
}

.select-all {
  float: left;
  margin-top: 0;
  margin-right: 7px;
}

.filter {
  position: absolute;
  right: 66px;
  top: 27px;
  .trigger {
    /* display: flex;
    justify-content: space-between; */

    .filtered-collection {
      max-width: 134px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: right;
      display: inline-block;
    }
  }

  span {
    color: var(--sub-color);
  }

  .chevron {
    color: var(--sub-color);
    padding-left: 5px;
    vertical-align: top;
  }
}

.select-text {
  margin-right: 10px;
}

.toggle {
  position: absolute;
  top: 25px;
  right: 25px;
}
</style>
